import { changeLoading } from "@/app/appSlice"
import { RootState } from "@/app/store"
import LangSelector from "@/features/LangSelector/LangSelector"
import { Outlet } from "react-router-dom"
import BeatLoader from "react-spinners/BeatLoader"
import { Fragment } from "react"
import { renderDLAPP } from "./dlapp"
import { currentTheme } from "@/theme"
export default function Layout() {
  const t = useTranslate()
  const backUrl = useAppSelector((state: RootState) => state.app.backUrl)
  const returnUrl = useAppSelector((state: RootState) => state.app.returnUrl)
  const loading = useAppSelector((state: RootState) => state.app.loading)
  const [displayLoading, setDisplayLoading] = useState(loading)
  const location = useLocation()

  useEffect(() => {
    setTimeout(() => {
      setDisplayLoading(loading)
    }, 500)
  }, [loading])

  const footerItems = [
    { heading: "sales", email: "sales@storellet.com" },
    { heading: "mkt", email: "marketing@storellet.com" },
    { heading: "techsupport", email: "support@storellet.com" },
  ]

  const goRedirectBack = () => {
    const url = returnUrl || backUrl
    console.log(url)
    window.location.href = url
  }

  const getPrimaryColor = () => {
    return getComputedStyle(document.documentElement)
      .getPropertyValue("--color-primary")
      .trim()
  }

  return (
    <div className="min-h-screen flex flex-col">
      {displayLoading && (
        <div
          className={clsx([
            "bg-white w-screen h-screen fixed inset-0 z-50 flex justify-around items-center transition-all duration-500",
            {
              "opacity-0": !loading,
              "opacity-100": loading,
            },
          ])}
        >
          <BeatLoader color={getPrimaryColor()} />
        </div>
      )}
      <div
        className={`flex py-2 px-4 lg:py-4 lg:px-8 justify-between items-center bg-header-bg text-header-text`}
      >
        <img className="object-contain w-36" src={currentTheme.logo} />
        <LangSelector />
      </div>
      {/* <div className="h-1 mb-4 bg-gradient-to-b from-neutral-300 to-transparent"></div> */}
      <div className="container text-center max-w-sm flex-grow px-2">
        <div className="mt-14 mb-10">
          <Outlet />
          {location.pathname !== "/success" && (
            <button
              className="white w-full m-0 mt-8"
              onClick={() => goRedirectBack()}
            >
              {t("back")}
            </button>
          )}
        </div>
      </div>
      <div className="bg-footer-bg text-footer-text">
        <div className="container w-[calc(100%-2rem)] mx-auto py-6 flex flex-wrap justify-between bg-theme-dark border-t border-white">
          {currentTheme.showFooterItems &&
            footerItems.map((f) => (
              <div key={`footer-${f.heading}`} className="mx-2 mb-2">
                <div
                  key={`footer-${f.heading}-heading`}
                  className="my-1 font-bold text-lg"
                >
                  {t(f.heading)}
                </div>
                <div className="my-1" key={`footer-${f.heading}-mail`}>
                  <a href={`mailto:${f.email}`}>{f.email}</a>
                </div>
              </div>
            ))}
          <div className="mx-2">
            <div className="my-1 font-bold text-lg">
              {t("downloadApp", {
                downloadAppName: currentTheme.downloadAppName,
              })}
            </div>
            {renderDLAPP({})}
          </div>
          <div className="w-full mt-4 flex flex-wrap justify-between">
            <div className="flex mr-2">
              {[
                {
                  url: currentTheme.facebookLink,
                  img: "/sns/Facebook.png",
                },
                {
                  url: currentTheme.instagramLink,
                  img: "/sns/Instagram.png",
                },
                { url: currentTheme.whatsappLink, img: "/sns/Whatsapp.png" },
              ]
                .filter((l) => l.url)
                .map((l) => (
                  <a target="_blank" href={l.url} key={`sns-${l.img}`}>
                    <img
                      className={`w-10 aspect-square object-contain cursor-pointer ${
                        currentTheme.isDarkFooter
                          ? "filter invert brightness(100)"
                          : ""
                      }`}
                      src={l.img}
                    />
                  </a>
                ))}
            </div>
            <div className="text-xs flex items-center">
              {t("copyright1")} {t("copyright2")}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
